<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<img src="../../assets/jiaofei-ok.jpg" >
				<h3 v-html="msg"></h3>
				
				<p>
					{{time321}}秒后自动返回首页
				</p>
				<div class="fcc">
					<div class="button-blue" @click="close">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-payCost',
		props: {
			msg:{
				type:String,
				default:"缴费成功，请取走凭条"
			}
		},
		data() {
			return {
				//timer:null,
				show:true,
				timer:null,
				time321:10
			}
		},
	
		
		mounted() {
			var that = this;
			that.timer = setInterval(function() {
				that.time321--
				if (that.time321 < 1) {
					that.openUrl('/index')
				}
			}, 1000)
		},
		methods: {
			close(){
				this.show=false
				this.$emit('close-read',false); 
				clearInterval(this.timer);
			}
		},
		beforeDestroy() {
			clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	.popBox{
		height: auto;
		padding-bottom: 80px;
	}
		.inner{
			padding-top:60px;
			text-align: center;
			img{
				height: 451x;
				margin-bottom: 40px;
			}
			h3{
				font-size: 57px;
				font-weight: 800;
				color: #3C90F0;
				line-height: 80px;
				
			}
			p{
				font-size: 38px;
				margin-top: 10px;
				color: #828282;
				margin-bottom: 42px;
			}
			
		}
</style>
